import {
	FETCH_ALL_APPIAN_ICERT_CASES,
	FETCH_ALL_APPIAN_ICERT_CASES_SUCCESS,
	FETCH_ALL_APPIAN_ICERT_CASES_FAILED
} from './actions/actions';

const initialState = {
	data: {},
	error: false,
	isLoading: true
};

export default (state = initialState, actions) => {
	switch (actions.type) {
		case FETCH_ALL_APPIAN_ICERT_CASES:
			return {
				...state,
				data: actions.payload
			};
		case FETCH_ALL_APPIAN_ICERT_CASES_SUCCESS:
			return {
				...state,
				data: actions.payload,
				isLoading: false,
				error: false
			};
		case FETCH_ALL_APPIAN_ICERT_CASES_FAILED:
			return {
				...state,
				data: {},
				error: true
			};
		default:
			return state;
	}
};
